import { render, staticRenderFns } from "./AccountNoteAssetUpdateModal.vue?vue&type=template&id=04a2b990"
import script from "./AccountNoteAssetUpdateModal.vue?vue&type=script&lang=js"
export * from "./AccountNoteAssetUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports